import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { UiKitTypographyBase } from '@/fo/ui/kit/typography/base';

import { ArticlePost } from '../../types';

import { styles } from './PreviewBlock.styles';

export interface PreviewBlockProps {
  post: ArticlePost;
}

export function PreviewBlock({ post }: PreviewBlockProps) {
  const slots = styles();

  const t = useTranslations();

  if (post.authors.length === 0 && !post.description) {
    return null;
  }

  return (
    <div className={slots.base()}>
      {post.description && (
        <UiKitTypographyBase className={slots.description()}>
          {post.description}
        </UiKitTypographyBase>
      )}
      {post.authors.length > 0 && (
        <div>
          <div className={slots.authorsTitle()}>
            {t('article.page.post.authorsTitle')}
          </div>
          <div className={slots.authors()}>
            {post.authors.map((author) => (
              <div
                className={slots.author()}
                key={author.id}
              >
                <Link
                  href={author.url}
                  className={slots.authorImageContainer()}
                >
                  <Image
                    className={slots.authorImage()}
                    src={author.image}
                    alt={author.name}
                    fill
                  />
                </Link>
                <div className={slots.authorInfo()}>
                  <Link
                    href={author.url}
                    className={slots.authorName()}
                  >
                    {author.name}
                  </Link>
                  {author.description && (
                    <Link
                      href={author.url}
                      className={slots.authorDescription()}
                      dangerouslySetInnerHTML={{
                        __html: author.description
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
